<template>
  <div class="application">
    <div class="app-top" v-loading="pageLoading">
      <div class="app_title">{{ $lang('应用管理') }}</div>
      <el-select style="width: 200px;" v-model="selectApp" :placeholder="$lang('请选择')" @change="AppChange">
        <el-option
          v-for="item in appList"
          :key="item.id"
          :label="item.appName"
          :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="bd_y"></div>
    <div style="padding:0 20px">
      <div class="tool">
        <div class="tool_left">
          <div class="red_g"></div>
          <div class="left_content">
            <div class="title">{{ $lang('API调试列表') }}</div>
            <div>
              <el-tooltip class="item" effect="dark" :content="$lang('添加想要与极兔对接的接口，并通过自动联调测试。')" placement="top">
                <i class="el-icon-warning-outline mal-10 cu-po"></i>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="tool_right"><el-button plain icon="el-icon-plus" @click="selectOpen">{{ $lang('添加API') }}</el-button></div>
      </div>
      <el-table class="table-style" :data="tableData" v-loading="pageLoading || infoLoading" :empty-text="$lang('暂无数据')" style="width: 100%;margin-top: 15px">
        <el-table-column prop="name" :label="$lang('接口名称')" width="180" align="center">
          <template slot-scope="{row}">
            <span>{{$lang(row.name)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$lang('接口类型')" width="100" align="center">
          <template slot-scope="{row}">
            <span>{{$lang(typeList[row.interfaceType])}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$lang('接口地址')" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.interfaceType === 0" class="hide-font">
              <el-tooltip class="item" effect="dark" :open-delay="500" placement="top-start">
                <span>{{scope.row.url }}</span>
                <div slot="content" style="width:300px">{{scope.row.url }}</div>
              </el-tooltip>
            </div>
            <el-input style="width:97%;margin-right:5px" v-model="scope.row.testUrl" v-else></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$lang('状态')" width="100" align="center">
          <template slot-scope="scope">
            <span class="font-style">{{ $lang(stateList[scope.row.status]) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$lang('操作')" width="180" align="center">
          <template slot-scope="scope">
            <div style="display:inline-block" @click="showFirst(scope.row)"><span class="font-do">{{ $lang('发起联调') }}</span></div>
            <el-tooltip class="item" effect="dark" :open-delay="500" :content="$lang('删除')" placement="top">
              <i class="el-icon-delete icon-style" @click="deleteTable(scope.row.interfaceId)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="tool mat-30">
        <div class="tool_left">
          <div class="red_g"></div>
          <div class="left_content">
            <div class="title">{{ $lang('待上线列表') }}</div>
            <div>
              <el-tooltip class="item" effect="dark" :content="$lang('查看已经完成全部测试流程并成功上线的接口')" placement="top">
                <i class="el-icon-warning-outline mal-10 cu-po"></i>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <el-table class="table-style" :data="lanchList" v-loading="pageLoading || infoLoading" style="width: 100%;margin-top: 15px">
        <el-table-column prop="name" :label="$lang('接口名称')" width="180" align="center">
          <template slot-scope="{row}">
            <span>{{$lang(row.name)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$lang('接口类型')" align="center">
          <template slot-scope="{row}">
            <span>{{$lang(typeList[row.interfaceType])}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$lang('状态')" align="center">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.status === 1 ? '#E60000' : '#606266' }">{{ $lang(stateList[scope.row.status]) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$lang('操作')" width="180" align="center">
          <template slot-scope="scope">
            <span class="font-do" @click="toLine(scope.row)" v-if="scope.row.status !== 1">{{ $lang('申请上线') }}</span>
            <el-tooltip class="item" effect="dark" :open-delay="500" :content="$lang('再次联调')" placement="top">
              <i class="iconfont iconanniu-zhongxinshengchengshuju again-icon" @click="showFirst(scope.row)" v-if="scope.row.status !== 1"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="tool mat-30">
        <div class="tool_left">
          <div class="red_g"></div>
          <div class="left_content">
            <div class="title">{{ $lang('已完成列表') }}</div>
            <div>
              <el-tooltip class="item" effect="dark" :content="$lang('已经通过测试的接口，可填写接口正式地址并申请上线')" placement="top">
                <i class="el-icon-warning-outline mal-10 cu-po"></i>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <el-table class="table-style" :data="onlineList" v-loading="pageLoading || infoLoading" :empty-text="$lang('暂无数据')" style="width: 100%;margin-top: 15px">
        <el-table-column prop="name" :label="$lang('接口名称')" width="180" align="center">
          <template slot-scope="{row}">
            <span>{{$lang(row.name)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" :label="$lang('日调用情况')" width="180" align="center">
          <template slot-scope="{row}" v-if="row.interfaceType === 0 && row.dailyRequestLimit">
            <p>{{ $lang('当前调用量') }}：{{ row.currentRequestVolume }}</p>
<!--            <el-tooltip effect="dark">-->
<!--              <el-progress :width="60" :hidden="60" type="circle" :percentage="percentageSet(row)" :color="customColors" :format="formatPercentage"></el-progress>-->
<!--              <span slot="content">-->
<!--                <p>{{ $lang('当前调用量') }}：{{ row.currentRequestVolume }}</p>-->
<!--                <p>{{ $lang('日调用上限') }}：{{ row.dailyRequestLimit  }}</p>-->
<!--              </span>-->
<!--            </el-tooltip>-->
          </template>
        </el-table-column>
        <el-table-column :label="$lang('接口类型')" align="center">
          <template slot-scope="{row}">
            <span>{{$lang(typeList[row.interfaceType])}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$lang('接口地址')" align="center">
          <template slot-scope="scope">
            <div style="display: flex;align-items: center;">
              <div class="hide-font">
                <el-tooltip class="item" effect="dark" :open-delay="500" placement="top-start">
                  <span >{{scope.row.interfaceType === 1 ? scope.row.urlCallback : scope.row.url}}</span>
                  <div slot="content" style="width:300px">{{scope.row.interfaceType === 1 ? scope.row.urlCallback : scope.row.url}}</div>
                </el-tooltip>
              </div>
              <div style="margin-left:10px;" v-if="scope.row.interfaceType === 1">
                <el-tooltip class="item" effect="dark" :open-delay="500" :content="$lang('编辑')" placement="top">
                  <i class="el-icon-edit cr_red" @click="toLine(scope.row)"></i>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$lang('状态')" width="80" align="center">
          <template slot-scope="scope">
            <span>{{ $lang(stateList[scope.row.status]) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$lang('操作')" width="80" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :open-delay="500" :content="$lang('再次联调')" placement="top">
              <i class="iconfont iconanniu-zhongxinshengchengshuju again-icon" @click="showFirst(scope.row)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" :open-delay="500" :content="$lang('申请提高上限')" placement="top" v-if="scope.row.interfaceType === 0">
              <i class="iconfont iconteshu-shijian again-icon" @click="upLimitApply(scope.row)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <SelectApi ref="selectApi" @refreshTable="getManagementList"/>
    <EditUrl ref="editUrl" @editApiUrl="editApiUrl"/>
    <LianTiao ref="liantiao" @selectApiClose="getManagementList"/>
    <el-dialog :title="$lang('接口信息')" class="editData" :visible.sync="dialogVisible" width="35%" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form label-position="top" :model="editFormData" ref="editData" :rules="editFormDataRule">
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item :label="$lang('API名称') + '：'">
              {{editFormData.name}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$lang('说明') + '：'">
              <p style="line-height:20px">{{editFormData.detail}}</p>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="URL：" prop='urlCallback'>
              <el-input v-model.trim="editFormData.urlCallback" :placeholder="$lang('请输入')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $lang('返回') }}</el-button>
        <el-button style="color: #FFFFFF !important;" type="primary" @click.native="save">{{ $lang('保存') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="onlineTitle" :visible.sync="onlineApplyVisible" :close-on-click-modal="false" class="online-apply-dialog">
      <div class="messagge-info" v-html="onlineMsg">

      </div>
      <div>
        <span>{{ $lang('日调用上限') }}：</span>
        <el-input v-model="onlineApplyForm.dailyRequestLimit" :maxlength="9" @keyup.native="onlineApplyForm.dailyRequestLimit = onlyNumber(onlineApplyForm.dailyRequestLimit)"></el-input>
        <span> = {{ dailyRequestLimit }}</span>
      </div>
      <span slot="footer">
        <el-button size="small" @click="onlineApplyVisible = false">{{ $lang('取消') }}</el-button>
        <el-button size="small" style="color: #FFF !important;" type="primary" @click="commitApplyInfo">{{ $lang('提交') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import SelectApi from './selectApi.vue'
import EditUrl from './editUrl.vue'
import LianTiao from './lianTiao.vue'
import { RESPONSE_SUCCESS } from '@/constants'
import { mapGetters } from 'vuex'
import { RULES } from '@/constants/rules'
export default {
  name: 'Application',
  components: { SelectApi, EditUrl, LianTiao },
  data() {
    const self = this
    return {
      pageLoading: false,
      infoLoading: false, // 表格数据loading
      typeList: { 0: '订阅类', 1: '注册类' },
      stateList: { 0: '未联调', 1: '审核中', 2: '已上线', 3: '已下线', 4: '待申请', 5: '审核不通过' },
      tableData: [],
      lanchList: [],
      onlineList: [],
      selectApp: '',
      appList: [],
      dialogVisible: false,
      editFormData: {},
      editFormDataRule:{
        urlCallback:[{ required: true, message: self.$lang('请输入URL'), trigger: 'blur' }, RULES.url]
      },
      auditStatus: 1, // 状态值为 (0,"已提交"),(1,"未认证"),(2,"已认证"),(3,"禁用");
      onlineApplyVisible: false,
      onlineApplyForm: {
        dailyRequestLimit: ''
      },
      dailyRequestLimit: '',
      onlineTitle: '',
      customColors: [
        {color: '#67C23A', percentage: 80},
        {color: '#E6A23C', percentage: 99.9},
        {color: '#e60000', percentage: 100}
      ],
      onlineMsg: ''
    }
  },
  async mounted() {
    await this.getAppList()
    this.getManagementList()
    this.isAuth()
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    formatPercentage(percentage) {
      return percentage > 999 ? '999+%' : `${percentage}%`
    },
    percentageSet(row) {
      const { dailyRequestLimit, currentRequestVolume = 0 } = row
      if (dailyRequestLimit) {
        const num = Number((currentRequestVolume / dailyRequestLimit * 100).toFixed(2))
        return num
      }
      return 0
    },
    onlyNumber(item) {
      if (item) {
        const item1 = item.replace(/[^\d]/g, '')
        const reg = new RegExp('([0]*)([1-9]+[0-9]+)', 'g')
        const item2 = item1.replace(reg, '$2')
        console.log(item2)
        switch (item2.length) {
          case 4:
            this.dailyRequestLimit = item2.substring(0,1) + this.$lang('千')
            break;
          case 5:
            this.dailyRequestLimit = item2.substring(0,1) + this.$lang('万')
            break;
          case 6:
            this.dailyRequestLimit = item2.substring(0,1) + this.$lang('十万')
            break;
          case 7:
            this.dailyRequestLimit = item2.substring(0,1) + this.$lang('百万')
            break;
          case 8:
            this.dailyRequestLimit = item2.substring(0,1) + this.$lang('千万')
            break;
          case 9:
            this.dailyRequestLimit = item2.substring(0,1) + this.$lang('亿')
            break;
          default:
            this.dailyRequestLimit = item2
            break;
        }
        return item1
      } else {
        this.dailyRequestLimit = ''
      }
    },
    /**
     * @description 切换应用
     */
    AppChange(val) {
      this.getManagementList(val)
    },
    /**
     * @description 应用列表数据
     */
    async getAppList() {
      this.pageLoading = true
      const { code, data, msg } = await this.$API.appList()
      if (code === RESPONSE_SUCCESS) {
        this.appList = data
        this.selectApp = data[0].id
      } else {
        this.appList = []
        this.$message.error(msg)
      }
      this.pageLoading = false
    },
    /**
     * @description 调试列表数据
     */
    async getManagementList(appId) {
      this.infoLoading = true
      const formData = new FormData()
      formData.append('appId', appId ? appId : this.selectApp)
      const { code, data, msg } = await this.$API.managementList(formData)
      if (code === RESPONSE_SUCCESS) {
        this.tableData = data.debugList || []
        this.lanchList = data.waitingList || []
        this.onlineList = data.completedList || []
        this.tableData.forEach(v => v.url && v.interfaceType === 0 ? v.url = 'https://demoopenapi.jtexpress.vn' + v.url : v.url = '')
        this.lanchList.forEach(v => v.url && v.interfaceType === 0 ? v.url = 'https://demoopenapi.jtexpress.vn' + v.url : v.url = '')
        this.onlineList.forEach(v => v.url && v.interfaceType === 0 ? v.url = 'https://demoopenapi.jtexpress.vn' + v.url : v.url = '')
      } else {
        this.$message.error(msg)
        this.tableData = []
        this.lanchList = []
        this.onlineList = []
      }
      this.infoLoading = false
    },
    inputFous(index) {
      this.tableData[index].isInput = false
    },
    cellClick(index) {
      this.tableData[index].isInput = true
    },
    deleteTable(id) {
      this.$confirm(this.$lang('你确定要将其从应用调试列表删除吗?'), this.$lang('提示'), {
        confirmButtonText: this.$lang('确定'),
        cancelButtonText: this.$lang('取消'),
        type: 'warning'
      }).then(() => {
        this.removeInterface(id)
      }).catch(() => {});
    },
    /**
     * @description 移除接口
     */
    async removeInterface(id) {
      const { code, msg } = await this.$API.removeInterface({ id, appId: this.selectApp })
      if (code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('删除成功'))
        this.getManagementList()
      } else {
        this.$message.error(msg)
      }
    },
    // 申请提高限制
    upLimitApply(row) {
      this.onlineApplyVisible = true
      this.onlineApplyForm = JSON.parse(JSON.stringify(row))
      if (this.onlineApplyForm.dailyRequestLimit) {
        this.onlineApplyForm.dailyRequestLimit = this.onlyNumber(row.dailyRequestLimit.toString())
      } else {
        this.dailyRequestLimit = ''
      }
      this.onlineTitle = this.$lang('调用上限申请')
      this.onlineMsg = this.$lang('请填写接口日调用最大限制')
    },
    toLine(row) { // 申请上线
      if (row.interfaceType === 1) {
        this.editFormData = row
        this.dialogVisible = true
      } else if (row.interfaceType === 0) {
        this.onlineApplyVisible = true
        this.onlineApplyForm = JSON.parse(JSON.stringify(row))
        this.onlineApplyForm.dailyRequestLimit = '20000'
        this.dailyRequestLimit = '2' + this.$lang('万')
        this.onlineMsg = `<i class="el-icon-warning" style="color: #e6a23c; font-size: 24px;"></i><span style="margin-left: 10px">${this.$lang('请确定是否将') + this.onlineApplyForm.name + this.$lang('接口申请上线？')}</span>`
        this.onlineTitle = this.$lang('上线申请')
      } else {
        this.$confirm(`${this.$lang('请确定是否将') + row.name + this.$lang('接口申请上线？')}`, this.$lang('上线申请'), {
          confirmButtonText: this.$lang('确定'),
          cancelButtonText: this.$lang('取消'),
          type: 'warning',
        }).then(() => {
          this.applySubmit({ id: row.id, userId: this.user.id, status: 1 })
        })
      }
    },
    commitApplyInfo() {
      const { id, dailyRequestLimit } = this.onlineApplyForm
      if (!dailyRequestLimit) {
        this.$message.warning(this.$lang('请输入调用上限'))
        return
      }
      if (this.onlineTitle === this.$lang('上线申请')) {
        this.applySubmit({ id, userId: this.user.id, status: 1, dailyRequestLimit })
      } else if (this.onlineTitle === this.$lang('调用上限申请')) {
        // 修改上线申请接口
        this.$API.applyLimit({ id, afterLimitNumber: dailyRequestLimit}).then(res => {
          if (res.code === RESPONSE_SUCCESS) {
            this.$message.success(this.$lang('保存成功'))
            this.dialogVisible = false
            this.onlineApplyVisible = false
            this.getManagementList()
          } else {
            this.$message.error(this.$lang(res.msg))
          }
        }).catch(err=>{
          if (err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error(this.$lang('网络繁忙，请重试'))
          }
        })

      }
    },
    /**
     * 弹出层保存
     */
    save(){
      this.$refs['editData'].validate((valid) => {
        if (valid) {
          this.applySubmit({ id:this.editFormData.id, userId: this.user.id,urlCallback:this.editFormData.urlCallback,status: 1})
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
     * 申请提交
     **/
    applySubmit(param){
      if(param.status == 0 || param.status == 3){
        //申请 停用时
        param.status = 1;//申请中
      }
      this.$API.apply(param).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.$message.success(this.$lang('保存成功'))
          this.dialogVisible = false
          this.onlineApplyVisible = false
          this.getManagementList()
        } else {
          this.$message.error(this.$lang(res.msg))
        }
      }).catch(err=>{
        if (err.msg) {
          this.$message.error(err.msg)
        } else {
          this.$message.error(this.$lang('网络繁忙，请重试'))
        }
      })
    },
    selectOpen() {
      this.$refs.selectApi.init(this.selectApp)
    },
    showEdit(row, index) {
      this.$refs.editUrl.init({ url: row.urlCallback, index })
    },
    editApiUrl(info) {
      const { url, index } = info
      this.onlineList[index].url = url
    },
    showFirst(row) {
      if (this.auditStatus !== 2) return this.$message.error(this.$lang('请先完成认证！'))
      if (row.interfaceType === 1 && row.testUrl) {
        this.$refs.liantiao.init({ ...row, pid: this.selectApp })
      } else if (row.interfaceType === 0 && row.url) {
        this.$refs.liantiao.init({ ...row, pid: this.selectApp })
      } else {
        this.$message.warning(this.$lang('接口地址不能为空！'))
      }
    },
    /**
     * @description 判断是否认证
     */
    isAuth() {
      this.$API.getCertificationInfo().then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.auditStatus = res.data.auditStatus
          // 这里需要判断是否认证通过，认证通过，并且uuid为空，即需要保存
          if(res.data.auditStatus == 2 && this.uuid.length == 0) {
            this.SET_UUID(res.data.uuid)
          }
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.application {
  ::v-deep .el-table__empty-text {
    font-size: 14px;
  }
  padding: 0 0 30px 0;
  .app-top {
    display: flex;
    align-items: center;
    padding: 15px 0;
    ::v-deep.el-input {
      width: 200px !important;
    }
  }
  .app_title {
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 600;
    color: #2b2b2b;
    margin: 0 20px 0 30px;
  }
  .bd_y {
    // width: 947px;
    height: 1px;
    background: #D9D9D9;
    margin-bottom: 22px;
  }
  .tool {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tool_left {
      display: flex;
      align-items: center;
      .red_g {
        width: 3px;
        height: 18px;
        background: #e60000;
        margin-right: 10px;
      }
      .left_content {
        display: flex;
        align-items: center;
        .title {
          font-size: 18px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 700;
          color: #2b2b2b;
        }
        .cu-po {
          cursor: pointer;
        }
      }
    }
  }
  .table-style {
    svg > path:nth-child(2) {
      stroke: url(#write);
    }
    ::v-deep .el-progress__text {
      font-size: 12px !important;
    }
    .font-style {
      color: #FF8909;
    }
    .font-do {
      color: #E60000;
      margin-right: 10px;
    }
    .font-do:hover {
      text-decoration:underline;
    }
    .font-do,
    .icon-style {
      cursor: pointer;
    }
    .icon-style {
      font-size: 16px;
    }
    .icon-style:hover {
      color: #E60000;
    }
    .hide-font {
      width: 95%;
      margin-right:5px;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }
  }
}
.mal-10 {
  margin-left: 10px;
}
.dis-flex {
  display: flex;
  align-items: center;
}
.cr_red {
  color: #E60000;
  font-size: 16px;
  cursor: pointer;
}
.mat-30 {
  margin-top: 30px;
}
</style>
<style lang="scss" scoped>
.online-apply-dialog {
  ::v-deep .el-dialog__body {
    padding-top: 0;
  }
  .messagge-info {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    span {
      margin-left: 12px;
    }
    .el-icon-warning {
      color: #e6a23c;
      font-size: 24px;
    }
  }
  .el-input {
    width: 150px;
  }
}
::v-deep .el-button.is-plain:hover, .el-button.is-plain:focus {
  color: #FFFFFF !important;
  background-color: #E60000 !important;
}
.el-button {
  border-color: #E60000 !important;
  color: #E60000 !important;
}
.editData::v-deep{
  .el-dialog{
    border-radius: 10px;
  }
  .el-form-item .el-form-item__label {
    color: #9499A3;
    padding: 0;
    line-height: 24px
  }
}
::v-deep .el-table th {
  background-color: #F2F2F2 !important;
}
.again-icon {
  font-size: 16px;
  display: inline-block;
  margin-left: 5px;
}
.again-icon:hover {
  color: #E60000;
  cursor: pointer;
}
</style>

